Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = getAirdogKeyName;
function getAirdogKeyName(data) {
  var eventData = data.event_data || {};
  return [data.event_name, eventData.page, eventData.section, eventData.sub_section, eventData.operation].filter(Boolean).join('.');
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-tracking/build/getAirdogKeyName.js
// module id = 474
// module chunks = 168707334958949